import { Text } from '@chakra-ui/react';

import { CompleteIcon } from 'shared-components';

import SectionStartTemplate from '../../templates/sectionStart';
import { useTranslation } from "react-i18next";

export interface IDispatchProps {
  onLogout: () => void;
}

const CourseConflictInfo = (props: IDispatchProps) => {
    const { t } = useTranslation('common');
  return (
    <SectionStartTemplate
      hideProgress={true}
      onNext={props.onLogout}
      proceedLabel="Log Out"
      section="Thank you for confirming your personal information"
    >
      <CompleteIcon />

      <Text fontSize="lg">{t('common:youWillBeNotifiedByEmailWhenItST')}</Text>
    </SectionStartTemplate>
  );
};

export default CourseConflictInfo;
